export default "__VITE_ASSET__0c008446__"